import { NskHead } from "~/components/common/head/NskHead";
import { Page } from "~/containers/specifics/admin/Page";

export const PATH = "/admin";

function Admin() {
	return (
		<>
			<NskHead title="Admin" />
			<Page />
		</>
	);
}

export default Admin;
